/** Радіус і розмір білої іконки плитки модуля за розміром плитки — пари з прототипу v4 (18→5/10 … 48→14/24). */
const KNOWN: Readonly<Record<number, readonly [number, number]>> = {
  18: [5, 10], 22: [6, 12], 24: [7, 13], 26: [7, 14], 28: [8, 15], 30: [9, 16], 32: [9, 17], 36: [10, 18], 44: [13, 22], 48: [14, 24],
};

/** Радіус кутів (≈28% сторони) і розмір гліфа (≈половина сторони) для довільного розміру плитки. */
export function moduleTileMetrics(size: number): { radius: number; glyph: number } {
  const known = KNOWN[size];
  return known ? { radius: known[0], glyph: known[1] } : { radius: Math.round(size * 0.28), glyph: Math.round(size * 0.52) };
}
